/** The UI languages: legacy TMS's eight. Every message file exists in each. */
export const languages = ['en', 'de', 'es', 'fr', 'ja', 'ko', 'pt', 'zh-CN'] as const

export type Language = (typeof languages)[number]

/** What any other language falls back to. */
export const fallbackLanguage: Language = 'en'

/**
 * The catalog language for a culture such as `de-AT` or `pt-BR`, or `null` when the catalog has
 * none. Chinese matches by script: Simplified (`zh`, `zh-CN`, `zh-SG`) gets `zh-CN`; Traditional
 * (`zh-TW`, `zh-HK`) gets nothing, as in legacy.
 */
export function catalogLanguageFor(culture: string): Language | null {
  let locale: Intl.Locale
  try {
    locale = new Intl.Locale(culture).maximize()
  } catch {
    return null
  }

  if (locale.language === 'zh') {
    return locale.script === 'Hans' ? 'zh-CN' : null
  }

  return languages.find((language) => language === locale.language) ?? null
}
